import { DgCellIcon } from 'src/app/core/interfaces/datagrid/dg-column';
import { EncryptionService } from 'src/app/core/services/utelize/general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { HttpClientService } from 'src/app/core/services/utelize/general/http-client-service';
import { Injectable } from '@angular/core';
import { MdmAccessService } from 'src/app/core/services/utelize/access/device-management/mdm-access.service';
import { MdmIntuneSimExceptionDeviceDTO } from 'src/app/core/models/system/device-management/mdm-intune-sim-exception-device.dto';
import { Observable, switchMap, throwError } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

export const INTUNE_ASSIGNMENT_EXCEPTION_TOOLTIP: string="Mismatch between SureSIM user assignment and Intune User assignment to this device";

@Injectable({ providedIn: 'root' })

export class MdmIntuneSimExceptionsService {

  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService,
    private mdmAccessService : MdmAccessService
  ) { }

  public async ensureInitialised(): Promise<void> {
    try {
      await this.mdmAccessService.ensureInitialised();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getAssignmentExceptionIcon=(rowData: any): DgCellIcon | undefined => {
    try {
      if (rowData?.intuneAssignmentException!==true)
        return undefined;

      if (!this.mdmAccessService.canShow())
        return undefined;

      return {
        colourClass: "text-warning",
        iconClass  : "ri-alert-fill",
        tooltip    : INTUNE_ASSIGNMENT_EXCEPTION_TOOLTIP
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public getIntuneDevices(exceptionId: number): Observable<MdmIntuneSimExceptionDeviceDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(exceptionId.toString(), true)
             .pipe(
               switchMap((encResult: StringResultDTO) => {
                 return this.httpClientService.get<MdmIntuneSimExceptionDeviceDTO[]>(
                          environment.eSimApi
                          + eSimApiPaths.MdmIntuneSimExceptions
                          + '/'
                          + eSimApiPaths.MdmIntuneSimExceptionsIntuneDevices
                          + "?idEncSS=" + encResult.result);
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return throwError(() => e);
    }
  }
}
